import { createIcon } from "@chakra-ui/react"

export const ShieldCheckRegular = createIcon({
  displayName: "ShieldCheck",
  viewBox: "0 0 20 20",
  path: (
    <path
      d="M4.28125 5.96875C4.09375 6.0625 4 6.21875 4 6.375C4 9.25 5.1875 14.1562 9.8125 16.375C9.90625 16.4375 10.0625 16.4375 10.1562 16.375C14.7812 14.1875 15.9688 9.25 16 6.375C16 6.21875 15.875 6.0625 15.7188 5.96875L10 3.5625L4.28125 5.96875ZM16.2812 4.59375C16.9688 4.90625 17.5 5.5625 17.5 6.375C17.4688 9.5 16.1875 15.1562 10.8125 17.75C10.2812 18 9.6875 18 9.15625 17.75C3.78125 15.1562 2.5 9.5 2.5 6.375C2.46875 5.5625 3 4.90625 3.6875 4.59375L9.5625 2.09375C9.6875 2.03125 9.84375 2 10 2C10.125 2 10.2812 2.03125 10.4062 2.09375L16.2812 4.59375ZM13.5312 8.53125L9.53125 12.5312C9.21875 12.8438 8.75 12.8438 8.46875 12.5312L6.46875 10.5312C6.15625 10.25 6.15625 9.78125 6.46875 9.5C6.75 9.1875 7.21875 9.1875 7.53125 9.5L9 10.9688L12.4688 7.5C12.75 7.1875 13.2188 7.1875 13.5312 7.5C13.8125 7.78125 13.8125 8.25 13.5312 8.53125Z"
      fill="#667085"
    />
  ),
})
